export const roles: string[] = [
  'manager',
  'billing',
  'frontdesk',
  'professional',
  'auxiliar',
  'employee',
];